import { AxiosPromise } from "axios";

import { get } from "@/shared/api/apiInstance";

export interface ProfileResponse {
  financeReceiverId: string;
  email: string;
  lastName: string;
  name: string;
  phone: string;
  salutation: string;
  unreadMessagesCount?: number;
}

export default function getProfile(): AxiosPromise<ProfileResponse> {
  return get("/me");
}
